import { Box } from "@mui/system";
import { useRef } from "react";

import AppModalTitle from "@/common/components/Modals/AppModalTitle";
import { useEntityInputFormInfo } from "@/common/hooks/entity/useEntityInputFormInfo";

import AppModalContent from "../../Modals/AppModalContent";
import {
  BaseEntityCreateUpdateModal,
  BaseEntityCreateUpdateModalInheritableProps,
} from "../components/BaseEntityCreateUpdateModal";
import VehicleCreateUpdate, {
  VehicleCreateUpdateHandle,
  VehicleCreateUpdateProps,
} from "./VehicleCreateUpdate";

interface Props extends BaseEntityCreateUpdateModalInheritableProps {
  createUpdateProps: VehicleCreateUpdateProps;
}

export default function VehicleCreateUpdateModal({ createUpdateProps, ...modalProps }: Props) {
  const formInfo = useEntityInputFormInfo({ entityId: createUpdateProps.entityId });
  const formWrapperRef = useRef<VehicleCreateUpdateHandle | null>(null);

  return (
    <BaseEntityCreateUpdateModal
      fullWidth
      maxWidth='lg'
      {...modalProps}
      formWrapperRef={formWrapperRef}
    >
      {(params) => (
        <>
          <AppModalTitle onClose={params.close}>
            {formInfo.isCreate ? "Create new" : "Edit"} vehicle
          </AppModalTitle>
          <AppModalContent>
            <Box sx={{ py: 1 }}>
              <VehicleCreateUpdate ref={formWrapperRef} {...createUpdateProps} />
            </Box>
          </AppModalContent>
        </>
      )}
    </BaseEntityCreateUpdateModal>
  );
}
